import { DataViewTypes } from '@mode/shared/contract-common';
import { RUNNING_QUERY_STATES } from '@mode/shared/contract-common';

/**
 * Check if still in progress.
 *
 * This polling helper is temporarily here with `pollSwitchViews` above until polling work is able to be fleshed out.
 */
export function isStillRunning(runState: DataViewTypes.QueryRunStatus): boolean {
  return RUNNING_QUERY_STATES.includes(runState);
}
